import { inject, Injectable } from '@angular/core';
import {
  AppTrackingTransparency,
  AppTrackingStatus,
  AppTrackingStatusResponse
} from 'capacitor-plugin-app-tracking-transparency';
import { PLATFORM_TOKEN, PlatformProvider } from '../tokens';
import { Log, Logger } from '../shared-services';

@Injectable({ providedIn: 'root' })
export class AppTrackingTransparencyService {
  private readonly platformProvider: PlatformProvider = inject(PLATFORM_TOKEN);
  private readonly logger: Logger = inject(Logger);

  async requestPermission(): Promise<AppTrackingStatus | null> {
    if (!this.platformProvider.isiOS) {
      return null;
    }

    try {
      const current: AppTrackingStatusResponse = await AppTrackingTransparency.getStatus();
      if (current.status !== 'notDetermined') {
        this.logger.log(Log.Startup, { message: `ATT already resolved: ${current.status}` });
        return current.status;
      }

      const response: AppTrackingStatusResponse = await AppTrackingTransparency.requestPermission();
      this.logger.log(Log.Startup, { message: `ATT prompt result: ${response.status}` });
      return response.status;
    } catch (error) {
      this.logger.log(Log.Startup, { message: `ATT request failed: ${(error as Error).message}` });
      return null;
    }
  }
}
